module.exports = __webpack_public_path__ + "static/vf_mouter_core.e500528c.svg";